/* dv-nav-portal 2026-07-23: the mobile menu <nav> lives inside .section-header,
   trapping it (and its close button) in the header stacking context. Move it to
   be a direct child of <body> so it covers the full screen above everything -
   including the header bar and announcement bar. The open/close still works
   because the theme toggles .nav-open / .open-drawer on <html>. */
(function () {
  function portal() {
    var nav = document.querySelector("nav.navigation.mobile") || document.querySelector(".navigation.horizontal.mobile");
    if (nav && nav.parentElement !== document.body) document.body.appendChild(nav);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", portal);
  else portal();
  window.addEventListener("load", portal);
})();